<script setup>
  defineProps({
    type: {
      type: String,
      default: 'button'
    }
  });
</script>

<template>
  <button
    :type="type"
    class="secondary-button inline-flex items-center rounded-md !border-[5px] border-primary px-5 py-2 text-[1rem] font-semibold capitalize text-white transition duration-300 ease-in-out hover:bg-primary hover:!text-white focus:outline-none dark:border-purple-400 dark:text-purple-400 dark:hover:bg-primary dark:hover:text-white"
  >
    <slot />
  </button>
</template>

<style scoped>
  .secondary-button :hover {
    color: white !important;
  }
</style>
